/* Serial Guard — blocks add-to-cart unless a 6-digit serial is provided */
console.log('Serial Guard script loaded and active');

function findCartFormFromTarget(target) {
  const el = target && target.closest ? target : null;
  // Try a series of strategies to locate the product add form
  return (
    (el && el.closest('form[action*="/cart/add"]')) ||  // absolute or relative
    (el && el.closest('form')) ||                       // nearest form (on product page there is usually one)
    (document.querySelector('product-form form')) ||    // Dawn inner form
    (document.querySelector('form[action*="/cart/add"]')) // fallback
  );
}

function validateAndReport(form) {
  // Only enforce if the field exists in THIS form
  const serial = form.querySelector('#serial-number');
  if (!serial) return true;

  const value = (serial.value || '').trim();
  const valid = /^\d{6}$/.test(value);
  console.log('Serial value:', value, 'Valid?', valid);

  // Render/clear inline message
  let msg = form.querySelector('.serial-error');
  if (!valid) {
    if (!msg) {
      msg = document.createElement('p');
      msg.className = 'serial-error form__message';
      msg.setAttribute('role', 'alert');
      serial.insertAdjacentElement('afterend', msg);
    }
    msg.textContent = 'Please enter a valid 6-digit serial number.';
    serial.setAttribute('aria-invalid', 'true');
    serial.focus();
  } else if (msg) {
    msg.textContent = '';
    serial.removeAttribute('aria-invalid');
  }
  return valid;
}

// 1) Intercept form submits (covers most themes)
document.addEventListener('submit', function (e) {
  console.log('Submit event detected');
  const form = findCartFormFromTarget(e.target);
  if (!form) return;
  if (!validateAndReport(form)) {
    e.preventDefault();
    e.stopImmediatePropagation();
    e.stopPropagation();
  }
}, true);

// 2) Intercept clicks on the Add to Cart button (themes that bypass submit)
document.addEventListener('click', function (e) {
  const btn = e.target.closest && e.target.closest('button[name="add"], [type="submit"][name="add"]');
  if (!btn) return;
  console.log('Click event detected (Add button)');
  const form = findCartFormFromTarget(btn);
  if (form && !validateAndReport(form)) {
    e.preventDefault();
    e.stopImmediatePropagation();
    e.stopPropagation();
  }
}, true);

// 3) Dawn-specific: hook the <product-form> custom element
if ('customElements' in window && customElements.whenDefined) {
  customElements.whenDefined('product-form').then(() => {
    try {
      const PF = customElements.get('product-form');
      if (!PF || !PF.prototype) return;
      const original = PF.prototype.onSubmitHandler;
      if (typeof original !== 'function') return;

      PF.prototype.onSubmitHandler = function (evt) {
        const form = this && this.form ? this.form : null;
        if (form && !validateAndReport(form)) {
          evt.preventDefault();
          evt.stopImmediatePropagation();
          return;
        }
        return original.call(this, evt);
      };
    } catch (err) {
      console.warn('Product-form hook skipped:', err);
    }
  });
}